















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { errorHandling } from '@/helpers/errorHandling';
import ListMessages from '../UI/list-messages.vue';
import { GrupoEnteralDetalheDTO, GrupoEnteralParmDTO } from '@/interfaces/enteral';
import * as service from '@/services/enteral-group';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
  },
})
export default class EnteralGroupForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: Number;
  @Prop()
  public open: boolean;

  private loading: boolean = false;
  private error: boolean = false;

  public dto: GrupoEnteralDetalheDTO = new GrupoEnteralDetalheDTO();

  public form: any = {
    valid: false,
    rules: {
      nome: [(v) => !!v || 'Informe o nome do Grupo Enteral'],
      ativo: [(v) => v != null || 'Informe o Status'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('open')
  public watchOpen(): void {
    setTimeout(() => {
      if (this.open) {
        this.init();
      }
    }, 300);
  }

  public init(): void {
    if (!this.id || this.loading) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getEnteralGroup(this.id).subscribe(
        (result) => {
          this.dto = result;
          this.loading = false;
        },
        (error) => {
          this.error = true;
          this.loading = false;
        },
      ),
    );
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');
    let parm = new GrupoEnteralParmDTO();
    parm.id = this.dto.id;
    parm.nome = this.dto.nome;
    parm.ativo = this.dto.ativo;
    this.addSubsc(
      service.saveEnteralGroup(parm).subscribe(
        (result) => {
          this.resetForm();
          this.loader.stop();
          this.$emit('save');
        },
        (error) => {
          this.loader.stop();
          this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true);
        },
      ),
    );
  }

  public resetForm(): void {
    this.dto = new GrupoEnteralDetalheDTO();
    this.$refs.form.resetValidation();
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public closeForm(): void {
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      this.closeAction,
    );
  }
}
